<template>
  <v-container>
    <v-dialog v-model="dialog.delete" scrollable persistent width="350">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-information</v-icon>
          Informasi
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="ma-0 body-1">
            Apakah anda yakin menghapus pemberitahuan
            <span class="font-weight-bold">
              {{ detail.notificationTitle }}
            </span>
            ?
          </p>
          <v-alert
            v-if="error.message"
            text
            type="error"
            class="custom-alert my-4"
          >
            <p class="body-2 mb-0">
              {{ error.message }}
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="red"
            elevation="0"
            :disabled="loadFormAnnouncement"
            class="text-capitalize"
            @click="deleteAnnouncementHandler(detail.notificationId)"
          >
            Hapus
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            :disabled="loadFormAnnouncement"
            @click="resetForm"
            class="white--text text-capitalize"
          >
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.template" scrollable persistent width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-information</v-icon>
          Template
          <v-btn
            class="mt-n1"
            icon
            dark
            top
            right
            absolute
            @click.stop="dialog.template = false"
          >
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-skeleton-loader
            class="ma-auto"
            :loading="loadAnnouncementTemplates"
            transition="fade-transition"
            :tile="false"
            type="table-row"
            v-for="index in loadAnnouncementTemplates ? 10 : 1"
            :key="index"
          >
            <v-data-table
              v-show="announcementTemplates.length >= 1"
              :headers="templateHeaders"
              mobile-breakpoint="1"
              hide-default-footer
              :items="announcementTemplates"
              fixed-header
            >
              <template v-slot:[`item.aksi`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      color="green"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="selectTemplate(item)"
                    >
                      <v-icon small left>mdi-alert-circle-outline</v-icon> Pilih
                    </v-btn>
                  </template>
                  <span>Pilih Template</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.notificationContent`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ item.notificationContent | address }}
                    </span>
                  </template>
                  <span>
                    {{ item.notificationContent }}
                  </span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-skeleton-loader>
          <div
            class="text-center text--secondary"
            v-show="
              !loadAnnouncementTemplates && announcementTemplates.length < 1
            "
          >
            <v-icon
              style="font-size: 60px; margin-top: 1.5em"
              color="light-green"
            >
              mdi-close-circle-outline
            </v-icon>
            <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
            <p>Data yang Anda cari tidak ada disini</p>
          </div>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-row no-gutters justify="space-between" align="center">
            <v-col>
              <div
                class="float-left"
                v-if="paginationAnnouncementTemplates.totalPage > 1"
              >
                <v-pagination
                  v-model="templatePage"
                  :length="paginationAnnouncementTemplates.totalPage"
                  :total-visible="5"
                  color="light-green"
                  @input="getAnnouncementTemplates({ page: templatePage })"
                  circle
                >
                </v-pagination>
              </div>
            </v-col>

            <v-col cols="2">
              <v-btn
                small
                color="#fff"
                elevation="0"
                class="text-capitalize grey--text text--darken-1 d-block ml-auto"
                @click.stop="dialog.template = false"
              >
                Batal
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.filter" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-filter</v-icon>
          Filter list Pemberitahuan
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="formFilter">
            <p class="subtitle-2 mb-3 text--secondary">
              Range tanggal pemberitahuan
            </p>
            <v-menu
              ref="start"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.start"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  readonly
                  color="light-green"
                  prepend-inner-icon="mdi-calendar-month"
                  label="Tanggal Mulai"
                  clearable
                  @click:clear="formFilter.start = ''"
                  v-model="formFilter.start"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                color="light-green"
                v-model="formFilter.start"
                @input="picker.start = false"
              >
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="end"
              min-width="290px"
              max-width="290px"
              transition="scale-transition"
              offset-y
              :nudge-right="40"
              :close-on-content-click="false"
              v-model="picker.end"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  dense
                  readonly
                  color="light-green"
                  prepend-inner-icon="mdi-calendar-month"
                  label="Tanggal Selesai"
                  clearable
                  @click:clear="formFilter.end = ''"
                  v-model="formFilter.end"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                color="light-green"
                v-model="formFilter.end"
                @input="picker.end = false"
              >
              </v-date-picker>
            </v-menu>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            class="text-capitalize grey--text text--darken-1"
            @click.stop="dialog.filter = false"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="orange lighten-1"
            elevation="0"
            @click="resetFilter"
            class="white--text text-capitalize"
          >
            Reset
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            @click="saveFilter"
            class="white--text text-capitalize"
          >
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.create" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-bullhorn</v-icon>
          {{
            selectedPage === 'update'
              ? 'Ubah'
              : selectedPage === 'repost'
              ? 'Sebarkan ulang'
              : selectedPage === 'detail'
              ? 'Detail'
              : 'Tambah'
          }}
          Pemberitahuan
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <template v-if="selectedPage !== 'detail'">
          <v-card-text class="pt-6">
            <ValidationObserver ref="observer">
              <v-form ref="form" :readonly="loadFormAnnouncement">
                <v-row no-gutters align="start">
                  <v-col
                    cols="8"
                    style="min-width: 100px;"
                    class="flex-grow-0 flex-shrink-1"
                  >
                    <ValidationProvider
                      name="Judul Pemberitahuan"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        dense
                        outlined
                        label="Judul Pemberitahuan"
                        color="light-green"
                        v-model="form.title"
                        :error-messages="formErrors.title || errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="4" class="flex-shrink-0">
                    <v-btn
                      style="border-radius: 0px 4px 4px 0px;"
                      elevation="0"
                      height="40"
                      block
                      color="grey darken-1"
                      class="text-capitalize white--text"
                      @click.stop="
                        dialog.template = true;
                        templatePage = 1;
                        getAnnouncementTemplates();
                      "
                    >
                      Pilih Dari Template
                    </v-btn>
                  </v-col>
                </v-row>
                <ValidationProvider
                  name="Deskripsi"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    outlined
                    dense
                    label="Deskripsi"
                    color="light-green"
                    v-model="form.content"
                    :error-messages="formErrors.content || errors"
                  >
                  </v-textarea>
                </ValidationProvider>
                <v-checkbox
                  v-if="selectedPage !== 'repost'"
                  class="mt-0"
                  color="light-green"
                  v-model="form.is_template"
                >
                  <template v-slot:label>
                    <div>
                      Jadikan template ?
                    </div>
                  </template>
                </v-checkbox>
              </v-form>
            </ValidationObserver>
            <v-alert
              v-if="error.message"
              text
              type="error"
              class="custom-alert my-4"
            >
              <p class="body-2 mb-0">
                {{ error.message }}
              </p>
            </v-alert>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-spacer></v-spacer>
            <v-btn
              small
              color="#fff"
              elevation="0"
              :disabled="loadFormAnnouncement"
              class="text-capitalize grey--text text--darken-1"
              @click="resetForm"
            >
              Batal
            </v-btn>
            <v-btn
              small
              light
              color="light-green"
              elevation="0"
              :disabled="loadFormAnnouncement"
              :loading="loadFormAnnouncement"
              @click="saveForm"
              class="white--text text-capitalize"
            >
              Sebarkan
            </v-btn>
          </v-card-actions>
        </template>
        <template v-if="selectedPage === 'detail'">
          <v-card-text class="pt-6">
            <v-list-item-title class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Judul:
              </p>
              {{ detail.notificationTitle }}
            </v-list-item-title>
            <v-list-item-title class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Template:
              </p>
              {{ detail.notificationIsTemplate === '1' ? 'Ya' : 'Tidak' }}
            </v-list-item-title>
            <v-list-item-title class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Deskripsi:
              </p>
              <p class="body-2 line-text" v-text="detail.notificationContent" />
            </v-list-item-title>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-spacer></v-spacer>
            <v-btn
              small
              color="#fff"
              elevation="0"
              class="text-capitalize grey--text text--darken-1"
              @click="resetForm"
            >
              Tutup
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text--secondary">List Pemberitahuan</div>
          </v-card-title>
          <v-card-subtitle class="mt-3">
            <v-sheet class="d-sm-flex align-center justify-space-between">
              <v-btn
                :block="$vuetify.breakpoint.name === 'xs'"
                color="light-green"
                class="text-capitalize"
                dark
                elevation="2"
                @click.stop="dialog.create = true"
              >
                <v-icon small>mdi-plus</v-icon> Pemberitahuan
              </v-btn>
              <v-sheet class="d-sm-flex mt-4 mt-sm-0 align-center">
                <v-text-field
                  dense
                  outlined
                  v-model="search"
                  hide-details
                  placeholder="Cari Pemberitahuan . . ."
                  clearable
                  color="light-green"
                  prepend-inner-icon="mdi-magnify"
                  class="mb-4 mb-sm-0 mr-sm-2"
                  :full-width="$vuetify.breakpoint.name === 'xs'"
                >
                </v-text-field>
                <v-row dense class="py-0">
                  <v-col>
                    <v-btn
                      :block="$vuetify.breakpoint.name === 'xs'"
                      color="grey lighten-3"
                      class="text-capitalize grey--text text--darken-1"
                      elevation="0"
                      @click.stop="dialog.filter = true"
                    >
                      Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-sheet>
            <v-container class="pa-0" v-if="filter.filtered">
              <v-row dense>
                <v-col cols="12" class="mt-2">
                  Filter By
                </v-col>
                <v-col class="py-0">
                  <v-chip-group show-arrows>
                    <v-chip
                      v-if="filter.start && filter.end"
                      close
                      @click:close="
                        formFilter.start = null;
                        formFilter.end = null;
                        saveFilter();
                      "
                    >
                      Tanggal {{ filter.start }} ~ {{ filter.end }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-subtitle>
          <v-card-text>
            <v-divider class="my-2" />
            <v-skeleton-loader
              class="ma-auto"
              :loading="loadAnnouncements"
              transition="fade-transition"
              :tile="false"
              type="table-row"
              v-for="index in loadAnnouncements ? 10 : 1"
              :key="index"
            >
              <v-data-table
                v-show="announcements.length >= 1"
                :headers="headers"
                mobile-breakpoint="1"
                hide-default-footer
                :items="announcements"
                fixed-header
                min-height="250px"
                :height="
                  $vuetify.breakpoint.name !== 'xs' && filter.filtered
                    ? 'calc(100vh - 60vh)'
                    : $vuetify.breakpoint.name !== 'xs'
                    ? 'calc(100vh - 50vh)'
                    : ''
                "
              >
                <template v-slot:[`item.aksi`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="green"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="toDetail(item)"
                      >
                        <v-icon small>mdi-alert-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Detail</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="blue darken-1"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="updateAnnouncementHandler(item)"
                      >
                        <v-icon small>mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="red"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          detail = item;
                          dialog.delete = true;
                        "
                      >
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.notificationContent`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ item.notificationContent | address }}
                      </span>
                    </template>
                    <span>
                      {{ item.notificationContent }}
                    </span>
                  </v-tooltip>
                </template>
                <template
                  v-slot:[`item.notificationInputDatetime`]="{
                    item
                  }"
                >
                  {{ item.notificationInputDatetime | datetime }}
                </template>
              </v-data-table>
            </v-skeleton-loader>
            <div
              class="text-center text--secondary"
              v-show="!loadAnnouncements && announcements.length < 1"
            >
              <v-icon
                style="font-size: 60px; margin-top: 1.5em"
                color="light-green"
              >
                mdi-close-circle-outline
              </v-icon>
              <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
              <p>Data yang Anda cari tidak ada disini</p>
            </div>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-row>
              <v-col
                v-if="
                  paginationAnnouncements.totalData > 0 &&
                    $vuetify.breakpoint.name !== 'xs'
                "
                cols="5"
              >
                <div class="body-2 font-weight-bold mt-4">
                  Total {{ paginationAnnouncements.totalData }} data
                </div>
              </v-col>
              <v-col
                v-if="paginationAnnouncements.totalPage > 1"
                :cols="$vuetify.breakpoint.name !== 'xs' ? '7' : '12'"
              >
                <div class="float-sm-right">
                  <v-pagination
                    v-model="page"
                    :length="paginationAnnouncements.totalPage"
                    :total-visible="5"
                    color="light-green"
                    @input="getAnnouncementsHandler()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import announcement from '@/mixins/announcement';
import debounce from 'lodash.debounce';
export default {
  mixins: [announcement],
  data() {
    return {
      search: '',
      detail: {},
      page: 1,
      templatePage: 1,
      filter: {
        filtered: false,
        start: null,
        end: null
      },
      formFilter: {
        start: null,
        end: null
      },
      picker: {
        start: false,
        end: false
      },
      form: {
        id: '',
        title: '',
        content: '',
        is_template: false
      },
      dialog: {
        create: false,
        delete: false,
        filter: false,
        template: false
      },
      selectedPage: '',
      headers: [
        {
          text: 'Aksi',
          value: 'aksi',
          align: 'start',
          width: 200,
          sortable: false,
          class: 'font-weight-black body-2'
        },
        {
          text: 'Judul',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'notificationTitle'
        },
        {
          text: 'Deskripsi',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'notificationContent'
        },
        {
          text: 'Tanggal',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'notificationInputDatetime'
        }
      ],
      templateHeaders: [
        {
          text: 'Judul',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'notificationTitle'
        },
        {
          text: 'Deskripsi',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'notificationContent'
        },
        {
          text: 'Aksi',
          value: 'aksi',
          align: 'center',
          width: 60,
          sortable: false,
          class: 'font-weight-black body-2'
        }
      ]
    };
  },
  watch: {
    search: {
      handler: debounce(function() {
        this.page = 1;
        this.getAnnouncementsHandler();
      }, 500),
      immediate: true
    }
  },
  methods: {
    async getAnnouncementsHandler() {
      const filters = [
        {
          type: 'string',
          field: 'notification_title',
          value: this.search,
          comparison: '<>'
        },
        {
          field: 'notification_input_datetime',
          type: 'date',
          value:
            this.filter.end && this.filter.end.length > 0
              ? `${this.filter.start}::${this.filter.end}`
              : '',
          comparison: 'bet'
        }
      ];
      const payload = {
        filters,
        page: this.page
      };
      await this.getAnnouncements(payload);
    },
    async saveFilter() {
      this.dialog.filter = false;
      this.page = 1;
      this.filter = {
        start: this.formFilter.start,
        end: this.formFilter.end
      };
      if (this.formFilter.start && this.formFilter.end) {
        this.filter.filtered = true;
      }
      await this.getAnnouncementsHandler();
    },
    async resetFilter() {
      this.dialog.filter = false;
      this.page = 1;
      this.filter = {
        filtered: false,
        start: null,
        end: null
      };
      this.formFilter = {
        start: null,
        end: null
      };
      await this.getAnnouncementsHandler();
    },
    toDetail(item) {
      this.detail = item;
      this.selectedPage = 'detail';
      this.dialog.create = true;
    },
    resetForm() {
      this.clearError();
      if (this.$refs.observer) this.$refs.observer.reset();
      this.dialog = {
        create: false,
        delete: false,
        filter: false,
        template: false
      };
      this.form = {
        id: '',
        title: '',
        content: '',
        is_template: false
      };
      this.selectedPage = '';
      this.detail = {};
    },
    async saveForm() {
      this.clearError();
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        try {
          if (this.form.id) {
            await this.updateAnnouncement(this.form, this.form.id);
          } else {
            await this.createAnnouncement(this.form);
          }
          this.page = 1;
          this.resetForm();
          await this.getAnnouncementsHandler();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }
    },
    updateAnnouncementHandler(announcement) {
      this.selectedPage = 'update';
      this.form = {
        id: announcement.notificationId,
        title: announcement.notificationTitle,
        content: announcement.notificationContent,
        is_template: announcement.notificationIsTemplate * 1 ? true : false
      };
      this.dialog.create = true;
    },
    selectTemplate(announcement) {
      this.selectedPage = 'repost';
      this.form = {
        id: announcement.notificationId,
        title: announcement.notificationTitle,
        content: announcement.notificationContent,
        is_template: false
      };
      this.dialog.template = false;
    },
    async deleteAnnouncementHandler(id) {
      this.clearError();
      try {
        await this.deleteAnnouncement(id);
        this.page = 1;
        this.resetForm();
        await this.getAnnouncementsHandler();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  }
};
</script>
